module.exports = __webpack_public_path__ + "img/prueba4.3b0cba2e.png";